<template>
  <div>
    <div class="text-sm-right mb-3">
<!--      <v-btn-->
<!--        v-show="(selected.length ? true : false)"-->
<!--        color="default"-->
<!--        dark-->
<!--        class="mb-2 mr-2"-->
<!--        @click="deleteMultipleItem"-->
<!--      >-->
<!--        Xóa tất cả-->
<!--      </v-btn>-->
      <v-btn
        color="primary"
        dark
        class="mb-2"
        v-if="checkAuthorization('agency-admin_create') || checkAuthorization('agency-user_create')"
        @click="addNewAgency"
      >
        <v-icon>mdi-plus</v-icon>Thêm Mới
      </v-btn>
    </div>
<!-- v-if="checkAuthorization('agency-management_delete')" -->
<!--    <v-tabs-->
<!--      class="mt-0 pl-3"-->
<!--      @change="changeTab"-->
<!--      v-model="tabIndex"-->
<!--      color="primary"-->
<!--      style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"-->
<!--    >-->
<!--      <v-tab :key="0">Tất Cả</v-tab>-->
<!--      <v-tab v-for="(tab, i) in productStatusOptions" :key="i+1">{{ tab.text }}</v-tab>-->
<!--    </v-tabs>-->

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="agencyList"
      :single-select="singleSelect"
      item-key="id"
      class="table-layout"
      style="height: calc(100vh - 280px) !important;overflow-y: auto !important;"
      hide-default-footer
      disable-sort
    >
      <template v-slot:top />
      <template v-slot:no-data>
        <common-no-result />
      </template>

      <template v-slot:item.name="{item}">
        <v-tooltip bottom v-if="item.name.length > 32">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ item.name.substring(0, 32) + "..." }}</span>
          </template>
          {{item.name}}
        </v-tooltip>
        <span v-else>{{item.name}}</span>
      </template>
      <template v-slot:item.detailAddress="{item}">
        <v-tooltip bottom v-if="item.detailAddress.length > 32">
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ item.detailAddress.substring(0, 32) + "..." }}</span>
          </template>
          {{item.detailAddress}}
        </v-tooltip>
        <span v-else>{{item.detailAddress}}</span>
      </template>
      <template v-slot:item.users="{item}">
        <div v-for="user in item.users" :key="user.id"><span>{{user.fullname}}</span><br></div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mr-2 ml-2"
              @click="detailAgency(item)"
              icon small
              color="primary"
              v-on="on"
            >
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
          </template>
          <span>Chi tiết đại lý</span>
        </v-tooltip>
        <v-tooltip v-if="checkAuthorization('agency-admin_update')" bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="mr-2 ml-2" @click="editAgency(item)" icon small color="primary"  v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
          </template>
          <span>Chỉnh sửa thông tin đại lý</span>
        </v-tooltip>
        <!-- <v-tooltip v-if="checkAuthorization('agency-admin_delete')" bottom>
          <template v-slot:activator="{ on }">
            <v-btn @click="onClickDelete(item)" icon small color="default"  v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
          </template>
          <span>Xóa đại lý</span>
        </v-tooltip> -->
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'

  const AgencyRepository = RepositoryFactory.get('agency')
  export default {
    components: {},
    props: {
      agencyList: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        selectedAgency: {},
        errorMessage: '',
        headers: [
          { text: 'ID', value: 'id', align: 'center', width: 50 },
          { text: 'Tên đại lý', value: 'name', align: 'center' },
          { text: 'SĐT đại lý', value: 'phone', align: 'center' },
          { text: 'Địa chỉ', value: 'detailAddress', align: 'center' },
          { text: 'NV kinh doanh', value: 'users', align: 'center' },
          { text: 'Thao tác', value: 'action', align: 'center', sortable: false }
          // { text: 'Đại lý', value: 'warehouse', align: 'center' },
        ],
        singleSelect: false,
        selected: [],
        productStatusOptions:[],
        tabIndex: 0,
        filterForm: {}
      }
    },
    created () {

    },
    methods: {
      addNewAgency () {
        this.$router.push({
          name: 'CreateAgency',
        })
      },

      editAgency (agency) {
        this.$router.push({
          name: 'EditAgency',
          params: {
            id: _.get(agency, 'id', 0),
          },
        })
      },
      detailAgency(agency) {
        this.$router.push({
          name: 'DetailAgency',
          params: {
            id: _.get(agency, 'id', 0),
          },
        })
      },
      async onClickDelete (agency) {
        this.$swal({
          title: 'Xóa đại lý',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const respond = await AgencyRepository.deleteOneItem(agency.id)
            loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Đã xóa thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('agency-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
      async deleteMultipleItem () {
        this.$swal({
          title: 'Xóa toàn bộ đại lý',
          text: 'Bạn có thực sự muốn xoá các đại lý này?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const response = await AgencyRepository.deleteManyItems(this.selected.map(s => s.id))
            loader.hide()
            if (response.success) {
              this.selected = []
              this.$swal({
                        title: 'Xoá thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                Bus.$emit('agency-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', ''),
              })
            }
          }
        })
      }
    }
  }
</script>
